import type { Component } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

import { DOCTYPES } from '@/constants/doctypes.ts'
import { PERMISSIONS } from '@/constants/permissions.ts'

const ACCOUNTING_REPORT_PERMISSIONS = [PERMISSIONS.READ]

const routeAccountingReportsBalanceSheet: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/viewsExternal/accountingReports/AccountingReportsView.vue')
  },
  meta: { doctypes: { [DOCTYPES.ACCOUNT]: ACCOUNTING_REPORT_PERMISSIONS } },
  name: 'accounting-reports-balance-sheet',
  path: 'balance-sheet',
}

const routeAccountingReportsProfitAndLoss: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/viewsExternal/accountingReports/AccountingReportsView.vue')
  },
  meta: { doctypes: { [DOCTYPES.ACCOUNT]: ACCOUNTING_REPORT_PERMISSIONS } },
  name: 'accounting-reports-profit-and-loss',
  path: 'profit-and-loss',
}

const routeAccountingReportsDatevExport: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/viewsExternal/accountingReports/AccountingReportsView.vue')
  },
  meta: { doctypes: { [DOCTYPES.ACCOUNT]: ACCOUNTING_REPORT_PERMISSIONS } },
  name: 'accounting-reports-datev-export',
  path: 'datev',
}

const routeAccountingReportsManagementReport: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/viewsExternal/accountingReports/AccountingReportsView.vue')
  },
  meta: { doctypes: { [DOCTYPES.ACCOUNT]: ACCOUNTING_REPORT_PERMISSIONS } },
  name: 'accounting-reports-management-report',
  path: 'management-report',
}

const routeAccountingReportsVatAdvanceReturn: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/viewsExternal/accountingReports/AccountingReportsView.vue')
  },
  meta: { doctypes: { [DOCTYPES.ACCOUNT]: ACCOUNTING_REPORT_PERMISSIONS } },
  name: 'accounting-reports-vat-advance-return',
  path: 'vat-advance-return',
}

const routeAccountingReportsHome: RouteRecordRaw = {
  name: 'accounting-reports-home',
  path: '',
  redirect: routeAccountingReportsBalanceSheet,
}

const routeAccountingReportsRoot: RouteRecordRaw = {
  children: [
    routeAccountingReportsHome,
    routeAccountingReportsBalanceSheet,
    routeAccountingReportsProfitAndLoss,
    routeAccountingReportsDatevExport,
    routeAccountingReportsManagementReport,
    routeAccountingReportsVatAdvanceReturn,
  ],
  path: 'reports',
}

export {
  routeAccountingReportsBalanceSheet,
  routeAccountingReportsDatevExport,
  routeAccountingReportsHome,
  routeAccountingReportsManagementReport,
  routeAccountingReportsProfitAndLoss,
  routeAccountingReportsRoot,
  routeAccountingReportsVatAdvanceReturn,
}
